import { WorkModeType, isValidMode } from './enums'

class Config {
  private readonly backendUrl: string
  private readonly tgBotName: string
  private readonly tgSupportBotName: string
  private readonly appMode: WorkModeType

  constructor() {
    this.backendUrl = import.meta.env.VITE_BACKEND_URL || ''
    this.tgBotName = import.meta.env.VITE_TG_BOT_NAME || ''
    this.tgSupportBotName = import.meta.env.VITE_TG_SUPPORT_BOT_NAME || ''
    this.appMode = (import.meta.env.VITE_NODE_ENV as WorkModeType) || null

    if (!this.backendUrl) {
      throw new Error('Missing required environment variable: BACKEND_URL')
    }
    if (!this.tgBotName) {
      throw new Error('Missing required environment variable: VITE_TG_BOT_NAME')
    }
    if (!this.tgSupportBotName) {
      throw new Error(
        'Missing required environment variable: VITE_TG_SUPPORT_BOT_NAME'
      )
    }
    if (!this.appMode || !isValidMode(this.appMode)) {
      this.appMode = 'development'
    }
  }

  getBackendUrl(): string {
    return this.backendUrl
  }
  getAppMode(): WorkModeType {
    return this.appMode
  }
  getTgBotName(): string {
    return this.tgBotName
  }
  getTgBotUrl(): string {
    return `https://t.me/${this.tgBotName}`
  }
  getTgBotSupportName(): string {
    return this.tgSupportBotName
  }
  getTgBotSupportUrl(): string {
    return `https://t.me/${this.tgSupportBotName}`
  }
  isDevAppMode(): boolean {
    return this.appMode === 'development'
  }
}

const config = new Config()

export default config
